import { render, staticRenderFns } from "./ExtrasCatalog.vue?vue&type=template&id=2a644646&"
import script from "./ExtrasCatalog.vue?vue&type=script&lang=js&"
export * from "./ExtrasCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports